import {
	ActivityType,
	CreditUse,
	HouseType,
	RegistryStepName,
	TransportationMethod
} from '@/gql/graphql';
import {
	OldestDuePayment,
	OperatingTimeRanges,
	DaysPerSimulationPeriod,
	CommitteeRuling
} from '@/graphql/__generated__/credit-requests';
import { TrialType, JuryType } from '@/graphql/__generated__/onboarding';
import { TaxRegimeCode } from '@/graphql/__generated__/onboarding-legal';

export const MexStates = {
	AGU: 'Aguascalientes',
	BCN: 'Baja California',
	BCS: 'Baja California Sur',
	CAM: 'Campeche',
	CHH: 'Chihuahua',
	CHP: 'Chiapas',
	CMX: 'Ciudad de México',
	COA: 'Coahuila',
	COL: 'Colima',
	DUR: 'Durango',
	GRO: 'Guerrero',
	GUA: 'Guanajuato',
	HID: 'Hidalgo',
	JAL: 'Jalisco',
	MEX: 'Estado de México',
	MIC: 'Michoacán',
	MOR: 'Morelos',
	NAY: 'Nayarit',
	NLE: 'Nuevo León',
	OAX: 'Oaxaca',
	PUE: 'Puebla',
	QUE: 'Querétaro',
	ROO: 'Quintana Roo',
	SIN: 'Sinaloa',
	SLP: 'San Luis Potosí',
	SON: 'Sonora',
	TAB: 'Tabasco',
	TAM: 'Tamaulipas',
	TLA: 'Tlaxcala',
	VER: 'Veracruz',
	YUC: 'Yucatán',
	ZAC: 'Zacatecas'
};

export const Nationalities = {
	MEX: 'Mexicana'
};

export const CountryCodes = {
	ABW: 'Aruba',
	AFG: 'Afghanistan',
	AGO: 'Angola',
	AIA: 'Anguilla',
	ALA: 'Åland Islands',
	ALB: 'Albania',
	AND: 'Andorra',
	ANT: 'Netherlands Antilles',
	ARE: 'United Arab Emirates',
	ARG: 'Argentina',
	ARM: 'Armenia',
	ASM: 'American Samoa',
	ATA: 'Antarctica',
	ATF: 'French Southern Territories',
	ATG: 'Antigua and Barbuda',
	AUS: 'Australia',
	AUT: 'Austria',
	AZE: 'Azerbaijan',
	BDI: 'Burundi',
	BEL: 'Belgium',
	BEN: 'Benin',
	BES: 'Bonaire, Sint Eustatius and Saba',
	BFA: 'Burkina Faso',
	BGD: 'Bangladesh',
	BGR: 'Bulgaria',
	BHR: 'Bahrain',
	BHS: 'Bahamas',
	BIH: 'Bosnia and Herzegovina',
	BLM: 'Saint Barthélemy',
	BLR: 'Belarus',
	BLZ: 'Belize',
	BMU: 'Bermuda',
	BOL: 'Bolivia',
	BRA: 'Brazil',
	BRB: 'Barbados',
	BRN: 'Brunei Darussalam',
	BTN: 'Bhutan',
	BVT: 'Bouvet Island',
	BWA: 'Botswana',
	CAF: 'Central African Republic',
	CAN: 'Canada',
	CCK: 'Cocos (Keeling Islands',
	CHE: 'Switzerland',
	CHL: 'Chile',
	CHN: 'China',
	CIV: "Côte d'Ivoire",
	CMR: 'Cameroon',
	COD: 'Congo, Democratic Republic of the',
	COG: 'Congo',
	COK: 'Cook Islands',
	COL: 'Colombia',
	COM: 'Comoros',
	CPV: 'Cabo Verde',
	CRI: 'Costa Rica',
	CUB: 'Cuba',
	CUW: 'Curaçao',
	CXR: 'Christmas Island',
	CYM: 'Cayman Islands',
	CYP: 'Cyprus',
	CZE: 'Czechia',
	DEU: 'Germany',
	DJI: 'Djibouti',
	DMA: 'Dominica',
	DNK: 'Denmark',
	DOM: 'Dominican Republic',
	DZA: 'Algeria',
	ECU: 'Ecuador',
	EGY: 'Egypt',
	ERI: 'Eritrea',
	ESH: 'Western Sahara',
	ESP: 'Spain',
	EST: 'Estonia',
	ETH: 'Ethiopia',
	FIN: 'Finland',
	FJI: 'Fiji',
	FLK: 'Falkland Islands (Malvinas',
	FRA: 'France',
	FRO: 'Faroe Islands',
	FSM: 'Micronesia (Federated States of',
	GAB: 'Gabon',
	GBR: 'United Kingdom',
	GEO: 'Georgia',
	GGY: 'Guernsey',
	GHA: 'Ghana',
	GIB: 'Gibraltar',
	GIN: 'Guinea',
	GLP: 'Guadeloupe',
	GMB: 'Gambia',
	GNB: 'Guinea-Bissau',
	GNQ: 'Equatorial Guinea',
	GRC: 'Greece',
	GRD: 'Grenada',
	GRL: 'Greenland',
	GTM: 'Guatemala',
	GUF: 'French Guiana',
	GUM: 'Guam',
	GUY: 'Guyana',
	HKG: 'Hong Kong',
	HMD: 'Heard Island and McDonald Islands',
	HND: 'Honduras',
	HRV: 'Croatia',
	HTI: 'Haiti',
	HUN: 'Hungary',
	IDN: 'Indonesia',
	IMN: 'Isle of Man',
	IND: 'India',
	IOT: 'British Indian Ocean Territory',
	IRL: 'Ireland',
	IRN: 'Iran (Islamic Republic of',
	IRQ: 'Iraq',
	ISL: 'Iceland',
	ISR: 'Israel',
	ITA: 'Italy',
	JAM: 'Jamaica',
	JEY: 'Jersey',
	JOR: 'Jordan',
	JPN: 'Japan',
	KAZ: 'Kazakhstan',
	KEN: 'Kenya',
	KGZ: 'Kyrgyzstan',
	KHM: 'Cambodia',
	KIR: 'Kiribati',
	KNA: 'Saint Kitts and Nevis',
	KOR: 'Korea (Republic of',
	KWT: 'Kuwait',
	LAO: "Lao People's Democratic Republic",
	LBN: 'Lebanon',
	LBR: 'Liberia',
	LBY: 'Libya',
	LCA: 'Saint Lucia',
	LIE: 'Liechtenstein',
	LKA: 'Sri Lanka',
	LSO: 'Lesotho',
	LTU: 'Lithuania',
	LUX: 'Luxembourg',
	LVA: 'Latvia',
	MAC: 'Macao',
	MAF: 'Saint Martin (French part',
	MAR: 'Morocco',
	MCO: 'Monaco',
	MDA: 'Moldova (Republic of',
	MDG: 'Madagascar',
	MDV: 'Maldives',
	MEX: 'Mexico',
	MHL: 'Marshall Islands',
	MKD: 'North Macedonia',
	MLI: 'Mali',
	MLT: 'Malta',
	MMR: 'Myanmar',
	MNE: 'Montenegro',
	MNG: 'Mongolia',
	MNP: 'Northern Mariana Islands',
	MOZ: 'Mozambique',
	MRT: 'Mauritania',
	MSR: 'Montserrat',
	MTQ: 'Martinique',
	MUS: 'Mauritius',
	MWI: 'Malawi',
	MYS: 'Malaysia',
	MYT: 'Mayotte',
	NAM: 'Namibia',
	NCL: 'New Caledonia',
	NER: 'Niger',
	NFK: 'Norfolk Island',
	NGA: 'Nigeria',
	NIC: 'Nicaragua',
	NIU: 'Niue',
	NLD: 'Netherlands',
	NOR: 'Norway',
	NPL: 'Nepal',
	NRU: 'Nauru',
	NZL: 'New Zealand',
	OMN: 'Oman',
	PAK: 'Pakistan',
	PAN: 'Panama',
	PCN: 'Pitcairn',
	PER: 'Peru',
	PHL: 'Philippines',
	PLW: 'Palau',
	PNG: 'Papua New Guinea',
	POL: 'Poland',
	PRI: 'Puerto Rico',
	PRK: "Korea (Democratic People's Republic of",
	PRT: 'Portugal',
	PRY: 'Paraguay',
	PSE: 'Palestine, State of',
	PYF: 'French Polynesia',
	QAT: 'Qatar',
	REU: 'Réunion',
	ROU: 'Romania',
	RUS: 'Russian Federation',
	RWA: 'Rwanda',
	SAU: 'Saudi Arabia',
	SDN: 'Sudan',
	SEN: 'Senegal',
	SGP: 'Singapore',
	SGS: 'South Georgia and the South Sandwich Islands',
	SHN: 'Saint Helena, Ascension and Tristan da Cunha',
	SJM: 'Svalbard and Jan Mayen',
	SLB: 'Solomon Islands',
	SLE: 'Sierra Leone',
	SLV: 'El Salvador',
	SMR: 'San Marino',
	SOM: 'Somalia',
	SPM: 'Saint Pierre and Miquelon',
	SRB: 'Serbia',
	SSD: 'South Sudan',
	STP: 'Sao Tome and Principe',
	SUR: 'Suriname',
	SVK: 'Slovakia',
	SVN: 'Slovenia',
	SWE: 'Sweden',
	SWZ: 'Eswatini',
	SXM: 'Sint Maarten (Dutch part',
	SYC: 'Seychelles',
	SYR: 'Syrian Arab Republic',
	TCA: 'Turks and Caicos Islands',
	TCD: 'Chad',
	TGO: 'Togo',
	THA: 'Thailand',
	TJK: 'Tajikistan',
	TKL: 'Tokelau',
	TKM: 'Turkmenistan',
	TLS: 'Timor-Leste',
	TON: 'Tonga',
	TTO: 'Trinidad and Tobago',
	TUN: 'Tunisia',
	TUR: 'Turkey',
	TUV: 'Tuvalu',
	TWN: 'Taiwan, Province of China',
	TZA: 'Tanzania, United Republic of',
	UGA: 'Uganda',
	UKR: 'Ukraine',
	UMI: 'United States Minor Outlying Islands',
	URY: 'Uruguay',
	USA: 'United States of America',
	UZB: 'Uzbekistan',
	VAT: 'Holy See',
	VCT: 'Saint Vincent and the Grenadines',
	VEN: 'Venezuela (Bolivarian Republic of',
	VGB: 'Virgin Islands (British',
	VIR: 'Virgin Islands (U.S.',
	VNM: 'Viet Nam',
	VUT: 'Vanuatu',
	WLF: 'Wallis and Futuna',
	WSM: 'Samoa',
	YEM: 'Yemen',
	ZAF: 'South Africa',
	ZMB: 'Zambia',
	ZWE: 'Zimbabwe'
};

export const CountryCodesES = {
	ABW: 'Aruba',
	AFG: 'Afganistán',
	AGO: 'Angola',
	AIA: 'Anguila',
	ALA: 'Islas Åland',
	ALB: 'Albania',
	AND: 'Andorra',
	ANT: 'Antillas Neerlandesas',
	ARE: 'Emiratos Árabes Unidos',
	ARG: 'Argentina',
	ARM: 'Armenia',
	ASM: 'Samoa Americana',
	ATA: 'Antártida',
	ATF: 'Territorios Australes Franceses',
	ATG: 'Antigua y Barbuda',
	AUS: 'Australia',
	AUT: 'Austria',
	AZE: 'Azerbaiyán',
	BDI: 'Burundi',
	BEL: 'Bélgica',
	BEN: 'Benín',
	BES: 'Bonaire, San Eustaquio y Saba',
	BFA: 'Burkina Faso',
	BGD: 'Bangladés',
	BGR: 'Bulgaria',
	BHR: 'Baréin',
	BHS: 'Bahamas',
	BIH: 'Bosnia y Herzegovina',
	BLM: 'San Bartolomé',
	BLR: 'Bielorrusia',
	BLZ: 'Belice',
	BMU: 'Bermudas',
	BOL: 'Bolivia',
	BRA: 'Brasil',
	BRB: 'Barbados',
	BRN: 'Brunéi Darussalam',
	BTN: 'Bután',
	BVT: 'Isla Bouvet',
	BWA: 'Botsuana',
	CAF: 'República Centroafricana',
	CAN: 'Canadá',
	CCK: 'Islas Cocos (Keeling',
	CHE: 'Suiza',
	CHL: 'Chile',
	CHN: 'China',
	CIV: 'Costa de Marfil',
	CMR: 'Camerún',
	COD: 'República Democrática del Congo',
	COG: 'Congo',
	COK: 'Islas Cook',
	COL: 'Colombia',
	COM: 'Comoras',
	CPV: 'Cabo Verde',
	CRI: 'Costa Rica',
	CUB: 'Cuba',
	CUW: 'Curazao',
	CXR: 'Isla de Navidad',
	CYM: 'Islas Caimán',
	CYP: 'Chipre',
	CZE: 'Chequia',
	DEU: 'Alemania',
	DJI: 'Yibuti',
	DMA: 'Dominica',
	DNK: 'Dinamarca',
	DOM: 'República Dominicana',
	DZA: 'Argelia',
	ECU: 'Ecuador',
	EGY: 'Egipto',
	ERI: 'Eritrea',
	ESH: 'Sahara Occidental',
	ESP: 'España',
	EST: 'Estonia',
	ETH: 'Etiopía',
	FIN: 'Finlandia',
	FJI: 'Fiyi',
	FLK: 'Islas Malvinas',
	FRA: 'Francia',
	FRO: 'Islas Feroe',
	FSM: 'Micronesia (Estados Federados de',
	GAB: 'Gabón',
	GBR: 'Reino Unido',
	GEO: 'Georgia',
	GGY: 'Guernsey',
	GHA: 'Ghana',
	GIB: 'Gibraltar',
	GIN: 'Guinea',
	GLP: 'Guadalupe',
	GMB: 'Gambia',
	GNB: 'Guinea-Bisáu',
	GNQ: 'Guinea Ecuatorial',
	GRC: 'Grecia',
	GRD: 'Granada',
	GRL: 'Groenlandia',
	GTM: 'Guatemala',
	GUF: 'Guayana Francesa',
	GUM: 'Guam',
	GUY: 'Guyana',
	HKG: 'Hong Kong',
	HMD: 'Islas Heard y McDonald',
	HND: 'Honduras',
	HRV: 'Croacia',
	HTI: 'Haití',
	HUN: 'Hungría',
	IDN: 'Indonesia',
	IMN: 'Isla de Man',
	IND: 'India',
	IOT: 'Territorio Británico del Océano Índico',
	IRL: 'Irlanda',
	IRN: 'Irán (República Islámica de',
	IRQ: 'Iraq',
	ISL: 'Islandia',
	ISR: 'Israel',
	ITA: 'Italia',
	JAM: 'Jamaica',
	JEY: 'Jersey',
	JOR: 'Jordania',
	JPN: 'Japón',
	KAZ: 'Kazajistán',
	KEN: 'Kenia',
	KGZ: 'Kirguistán',
	KHM: 'Camboya',
	KIR: 'Kiribati',
	KNA: 'San Cristóbal y Nieves',
	KOR: 'Corea (República de',
	KWT: 'Kuwait',
	LAO: 'República Democrática Popular Lao',
	LBN: 'Líbano',
	LBR: 'Liberia',
	LBY: 'Libia',
	LCA: 'Santa Lucía',
	LIE: 'Liechtenstein',
	LKA: 'Sri Lanka',
	LSO: 'Lesoto',
	LTU: 'Lituania',
	LUX: 'Luxemburgo',
	LVA: 'Letonia',
	MAC: 'Macao',
	MAF: 'San Martín (parte francesa',
	MAR: 'Marruecos',
	MCO: 'Mónaco',
	MDA: 'Moldavia (República de',
	MDG: 'Madagascar',
	MDV: 'Maldivas',
	MEX: 'México',
	MHL: 'Islas Marshall',
	MKD: 'Macedonia del Norte',
	MLI: 'Malí',
	MLT: 'Malta',
	MMR: 'Myanmar',
	MNE: 'Montenegro',
	MNG: 'Mongolia',
	MNP: 'Islas Marianas del Norte',
	MOZ: 'Mozambique',
	MRT: 'Mauritania',
	MSR: 'Montserrat',
	MTQ: 'Martinica',
	MUS: 'Mauricio',
	MWI: 'Malaui',
	MYS: 'Malasia',
	MYT: 'Mayotte',
	NAM: 'Namibia',
	NCL: 'Nueva Caledonia',
	NER: 'Níger',
	NFK: 'Isla Norfolk',
	NGA: 'Nigeria',
	NIC: 'Nicaragua',
	NIU: 'Niue',
	NLD: 'Países Bajos',
	NOR: 'Noruega',
	NPL: 'Nepal',
	NRU: 'Nauru',
	NZL: 'Nueva Zelanda',
	OMN: 'Omán',
	PAK: 'Pakistán',
	PAN: 'Panamá',
	PCN: 'Islas Pitcairn',
	PER: 'Perú',
	PHL: 'Filipinas',
	PLW: 'Palaos',
	PNG: 'Papúa Nueva Guinea',
	POL: 'Polonia',
	PRI: 'Puerto Rico',
	PRK: 'Corea (República Popular Democrática de',
	PRT: 'Portugal',
	PRY: 'Paraguay',
	PSE: 'Palestina, Estado de',
	PYF: 'Polinesia Francesa',
	QAT: 'Catar',
	REU: 'Reunión',
	ROU: 'Rumania',
	RUS: 'Federación de Rusia',
	RWA: 'Ruanda',
	SAU: 'Arabia Saudita',
	SDN: 'Sudán',
	SEN: 'Senegal',
	SGP: 'Singapur',
	SGS: 'Islas Georgias del Sur y Sandwich del Sur',
	SHN: 'Santa Elena, Ascensión y Tristán de Acuña',
	SJM: 'Svalbard y Jan Mayen',
	SLB: 'Islas Salomón',
	SLE: 'Sierra Leona',
	SLV: 'El Salvador',
	SMR: 'San Marino',
	SOM: 'Somalia',
	SPM: 'San Pedro y Miquelón',
	SRB: 'Serbia',
	SSD: 'Sudán del Sur',
	STP: 'Santo Tomé y Príncipe',
	SUR: 'Surinam',
	SVK: 'Eslovaquia',
	SVN: 'Eslovenia',
	SWE: 'Suecia',
	SWZ: 'Esuatini',
	SXM: 'Sint Maarten (parte neerlandesa',
	SYC: 'Seychelles',
	SYR: 'República Árabe Siria',
	TCA: 'Islas Turcas y Caicos',
	TCD: 'Chad',
	TGO: 'Togo',
	THA: 'Tailandia',
	TJK: 'Tayikistán',
	TKL: 'Tokelau',
	TKM: 'Turkmenistán',
	TLS: 'Timor-Leste',
	TON: 'Tonga',
	TTO: 'Trinidad y Tobago',
	TUN: 'Túnez',
	TUR: 'Turquía',
	TUV: 'Tuvalu',
	TWN: 'Taiwán, Provincia de China',
	TZA: 'Tanzania, República Unida de',
	UGA: 'Uganda',
	UKR: 'Ucrania',
	UMI: 'Islas Ultramarinas Menores de Estados Unidos',
	URY: 'Uruguay',
	USA: 'Estados Unidos de América',
	UZB: 'Uzbekistán',
	VAT: 'Santa Sede',
	VCT: 'San Vicente y las Granadinas',
	VEN: 'Venezuela (República Bolivariana de',
	VGB: 'Islas Vírgenes (Británicas',
	VIR: 'Islas Vírgenes (EE.UU.',
	VNM: 'Vietnam',
	VUT: 'Vanuatu',
	WLF: 'Wallis y Futuna',
	WSM: 'Samoa',
	YEM: 'Yemen',
	ZAF: 'Sudáfrica',
	ZMB: 'Zambia',
	ZWE: 'Zimbabue'
};

export const Occupations = {
	GOVERNMENT_EMPLOYEE: 'GovernmentEmployee',
	OTHER: 'Other',
	PRIVATE_SECTOR: 'PrivateSector',
	STUDENT: 'Student'
};

export const TaxRegimeCodes = {
	CODE_605: 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
	CODE_606: 'Arrendamiento',
	CODE_608: 'Demás ingresos',
	CODE_611: 'Ingresos por Dividendos (socios y accionistas',
	CODE_612: 'Personas Físicas con Actividades Empresariales y Profesionales',
	CODE_614: 'Ingresos por intereses',
	CODE_615: 'Régimen de los ingresos por obtención de premios',
	CODE_616: 'Sin obligaciones fiscales',
	CODE_621: 'Incorporación Fiscal',
	CODE_622: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
	CODE_626: 'Régimen Simplificado de Confianza',
	CODE_629: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales',
	CODE_630: 'Enajenación de acciones en bolsa de valores'
};

export const RelationWithAddressOwner = {
	CHILD: 'Child',
	FAMILY: 'Family',
	MYSELF: 'Myself',
	OTHER: 'Other',
	PARENT: 'Parent',
	SIBLING: 'Sibling',
	TENANT: 'Tenant'
};

export const registryStatus: Record<RegistryStepName, string> = {
	BIRTH_INFORMATION: 'BirthInformation',
	COMPLETED: 'Completed',
	CREATED: 'Created',
	CORRECTIONS_REQUESTED: 'CorrectionsRequested',
	PERSONAL_INFORMATION: 'PersonalInformation',
	TAX_INFORMATION: 'TaxInformation',
	APPROVAL: 'ApprovedStatus',
	OFFICIAL_ADDRESS: 'OfficialAddress'
};

export const HouseTypeMap: Record<HouseType, string> = {
	FAMILY: 'Family',
	MORTGAGED: 'Mortgaged',
	OWNED: 'Owned',
	RENTED: 'Renterd'
};

export const TransportationMethodMap: Record<TransportationMethod, string> = {
	BIKE: 'Bike',
	CAR: 'Car',
	PUBLIC_TRANSPORT: 'PublicTransport',
	WALK: 'Walk'
};

export const CreditUseMap: Record<CreditUse, string> = {
	FINCLU_VAN: 'FincluVan',
	EXPANDING_BUSINESS: 'ExpandingBusiness',
	HOUSING: 'Housing',
	OTHER: 'Other',
	STARTING_BUSINESS: 'StartingBusiness',
	VEHICLE: 'Vehicle'
};

export const BusinessActivityMap: Record<ActivityType, string> = {
	AGRICULTURE: 'Agriculture',
	COMMERCE: 'Commerce',
	EMPLOYEE: 'Employee',
	HOTEL: 'Hotel',
	MANUFACTURING: 'Manufacturing',
	OTHER: 'Other',
	RESTAURANT: 'Restaurant',
	TRANSPORTATION: 'Transportation'
};

export const OperatingTimeRangeMap: Record<OperatingTimeRanges, string> = {
	BETWEEN_SIXTH_AND_TENTH_YEAR: 'BetweenSixthAndTenthYear',
	IN_FIFTH_YEAR: 'InFifthYear',
	IN_FOURTH_YEAR: 'InFourthYear',
	IN_SECOND_YEAR: 'InSecondYear',
	IN_THIRD_YEAR: 'InThirdYear',
	IN_FIRST_YEAR: 'InFirstYear',
	MORE_THAN_TEN_YEARS: 'MoreThanTenYears'
};

export const OldestDuePaymentMap: Record<OldestDuePayment, string> = {
	CODE_UR: 'NoInformation',
	CODE_00: 'TooRecent',
	CODE_01: 'NoLatePayments',
	CODE_02: 'OneToTwentyNineDays',
	CODE_03: 'ThirtyToFiftyNineDays',
	CODE_04: 'SixtyToEightyNineDays',
	CODE_05: 'NinetyToOneHundredNineteenDays',
	CODE_06: 'OneHundredTwentyToOneHundredFourtyNineDays',
	CODE_07: 'OneHundredFiftyToOneYear',
	CODE_96: 'MoreThanOneYear',
	CODE_97: 'ParcialOrTotalDebt',
	CODE_99: 'ClientFraud'
};

export const PeridicityDaysMap: Record<DaysPerSimulationPeriod, string> = {
	WEEKLY: '7',
	BIWEEKLY: '15',
	MONTHLY: '30'
};

export const CommitteeRulingMap: Record<CommitteeRuling, string> = {
	APPROVED_BY_COMMITTEE: 'ApprovedByCommittee',
	REJECTED_BY_COMMITTEE: 'RejectedByCommittee'
};

export const TaxRegimeCodeMap: Record<TaxRegimeCode, string> = {
	CODE_601: 'General',
	CODE_603: 'NonProfit',
	CODE_609: 'Salaries',
	CODE_620: 'Cooperative',
	CODE_622: 'Agricultural',
	CODE_623: 'OptionalForGroups',
	CODE_624: 'Coordinated',
	CODE_626: 'Resico',
	CODE_628: 'Hydrocarbons',
	CODE_629: 'Multinational',
	CODE_630: 'StockExchange'
};

export const TrialTypeMap: Record<TrialType, string> = {
	REAL_ESTATE_LEASE: 'RealEstateLease',
	BANKRUPTCY_INSOLVENCY: 'BankruptcyInsolvency',
	EVICTION: 'Eviction',
	EXECUTIVE_PROCEEDING: 'ExecutiveProceeding',
	COMMERCIAL_EXECUTIVE_PROCEEDING: 'CommercialExecutiveProceeding',
	SPECIAL_MORTGAGE_PROCEEDING: 'SpecialMortgageProceeding',
	MORTGAGE_PROCEEDING: 'MortgageProceeding',
	CIVIL_MORTGAGE_PROCEEDING: 'CivilMortgageProceeding',
	COMMERCIAL: 'Commercial',
	ORAL_MORTGAGE_PROCEEDING: 'OralMortgageProceeding',
	ORAL_COMMERCIAL_PROCEEDING: 'OralCommercialProceeding',
	ORDINARY_COMMERCIAL_PROCEEDING: 'OrdinaryCommercialProceeding',
	SUMMARY_MORTGAGE_PROCEEDING: 'SummaryMortgageProceeding',
	JACTITATION_ACTION: 'JactitationAction',
	CHILD_SUPPORT: 'ChildSupport',
	AMPARO_TRIAL: 'AmparoTrial',
	FAMILY_DISPUTE: 'FamilyDispute',
	CIVIL: 'Civil',
	CHILD_SUPPORT_CANCELLATION: 'ChildSupportCancellation',
	CONTESTED_DIVORCE: 'ContestedDivorce',
	MANDATORY_DIVORCE: 'MandatoryDivorce',
	DAMAGES_AND_LOSSES: 'DamagesAndLosses',
	CIVIL_EXECUTIVE_PROCEEDING: 'CivilExecutiveProceeding',
	FAMILY: 'Family',
	ORAL_FAMILY_PROCEEDING: 'OralFamilyProceeding',
	FIRST_REGISTRATION_OF_TITLE: 'FirstRegistrationOfTitle',
	INJUNCTION_PROCEEDING: 'InjunctionProceeding',
	AMPARO_LAWSUIT: 'AmparoLawsuit',
	NULLITY_LAWSUIT: 'NullityLawsuit',
	VOLUNTARY_JURISDICTION: 'VoluntaryJudicition',
	LABOR: 'Labor',
	UNPUBLISHED: 'Unpublished',
	NULLITY: 'Nullity',
	ORAL_CIVIL_PROCEEDING: 'OralCivilProceeding',
	ORAL_PROCEEDING: 'OralProceeding',
	ORDINARY_CIVIL_PROCEEDING: 'OrdinaryCivilProceeding',
	ORDINARY_PROCEEDING: 'OrdinaryProceeding',
	OTOR_FIR_ESC: 'OtorFirEsc',
	ACQUISITIVE_PRESCRIPTION: 'AcquisitivePrescription',
	JUSTICE_OF_THE_PEACE: 'JusticeOfThePeace',
	CRIMINAL: 'Criminal',
	PLEDGE_PROCEEDING: 'PledgeProceeding',
	POSITIVE_PRESCRIPTION: 'PositivePrescription',
	PESO_PAYMENT: 'PesoPayment',
	REIVINDICATORY_ACTION: 'ReivindicationAction',
	RESCISSION: 'Resciession',
	CHILD_SUPPORT_REDUCTION: 'ChildSupportReduction',
	SUMMARY_CIVIL_PROCEEDING: 'SummaryCivilProceeding',
	VERY_SUMMARY_CIVIL_PROCEEDING: 'VerySummaryCivilProceeding',
	SPECIAL_SUMMARY_PROCEEDING: 'SpecialSummaryProceeding',
	SUMMARY_PROCEEDING: 'SummaryProceeding',
	ADVERSE_POSSESSION: 'AdversePossession',
	NOT_APPLICABLE: 'NotApplicable'
};

export const JuryTypeMap: Record<JuryType, string> = {
	CRIMINAL_TRIAL: 'CriminalTrial',
	AMPARO_TRIAL: 'AmparoTrial',
	CIVIL_COMMERCIAL_OR_FAMILY_DEFENDANT: 'CivilCommercialOrFamilyDefendant',
	CIVIL_COMMERCIAL_OR_FAMILY_CO_DEFENDANT: 'CivilCommercialOrFamilyCoDefendant',
	NOT_APPLICABLE: 'NotApplicable'
};
